"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomTheme = void 0;
// eslint-disable-next-line no-shadow
var CustomTheme;
(function (CustomTheme) {
    CustomTheme["BIRDS_OF_PARADISE"] = "birds-of-paradise";
    CustomTheme["COBALT"] = "cobalt";
    CustomTheme["DARK_MODERN"] = "dark-modern";
    CustomTheme["DRACULA"] = "dracula";
    CustomTheme["GITHUB"] = "github";
    CustomTheme["GITHUB_DARK"] = "github-dark";
    CustomTheme["GITHUB_LIGHT"] = "github-light";
    CustomTheme["IDLE_FINGERS"] = "idle-fingers";
    CustomTheme["LIGHT_MODERN"] = "light-modern";
    CustomTheme["MONO_INDUSTRIAL"] = "mono-industrial";
    CustomTheme["MONOKAI_PRO_SPECTRUM"] = "monokai-pro-spectrum";
    CustomTheme["PASTELS_ON_DARK"] = "pastels-on-dark";
    CustomTheme["SLUSH_AND_POPPIES"] = "slush-and-poppies";
    CustomTheme["XCODE"] = "xcode";
})(CustomTheme || (exports.CustomTheme = CustomTheme = {}));
